module.exports = __webpack_public_path__ + "static/sample-projects-13-6b9839b2ed14c9053cfdf9dea2304ea0.png";